import { useEffect, useState } from "react";

export function StagingBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    fetch("/api/v1/config", { credentials: "include" })
      .then((r) => r.json())
      .then((d: { env: string }) => { if (d.env === "staging") setVisible(true); })
      .catch(() => {});
  }, []);

  if (!visible) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#F59E0B",
        color: "#1C1917",
        textAlign: "center",
        padding: "4px 0",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        fontFamily: "ui-monospace, monospace",
      }}
    >
      Staging environment
    </div>
  );
}
